import { sdkRequest, translateServerErrors } from '@eventbrite/http';
import { gettext } from '@eventbrite/i18n';
import { deepKeysToCamel } from '@eventbrite/transformation-utils';
import { formatUrl } from 'url-lib';
import {
    FinancialInformationAPIResponse,
    FinancialInformationValues,
    TaxpayerInformationAPIResponse,
    TaxpayerInformationValues,
} from '../types';
import { isLaunchFinanceSettingsEnabled } from '../utils';

const NOT_AUTHORIZED_ERROR = gettext(
    'You do not have permission to access the resource you requested.',
);
const SUBSCRIPTION_NOT_FOUND = gettext(
    'The profile you requested does not exist.',
);
const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);
const GENERAL_ERROR_SPEC = {
    NOT_AUTHORIZED: () => NOT_AUTHORIZED_ERROR,
    SUBSCRIPTION_NOT_FOUND: () => SUBSCRIPTION_NOT_FOUND,
    USER_HAS_NO_PASSWORD: () => 'USER_HAS_NO_PASSWORD',

    default: () => STANDARD_SERVER_ERROR,
};

const getFinanceAPIUrl = (organizerId: string): string => {
    return isLaunchFinanceSettingsEnabled()
        ? `/api/v3/organizations/${organizerId}/financial_information/`
        : `/api/v3/organizations/${organizerId}/active_taxpayer_information/`;
};

export const fetchTaxpayerInformationSummary = (
    orgId: string,
): Promise<FinancialInformationValues | TaxpayerInformationValues> =>
    sdkRequest(formatUrl(getFinanceAPIUrl(orgId)))
        .then(
            (
                data:
                    | FinancialInformationAPIResponse
                    | TaxpayerInformationAPIResponse
                    | {},
            ) => deepKeysToCamel(data),
        )
        .catch(translateServerErrors(GENERAL_ERROR_SPEC));
